import { inject, Injectable } from '@angular/core';
import { PlatformSettingsFacade } from '@p2p/platform-settings/domain';

@Injectable()
export class PlatformSettingsApiService {
    private readonly platformSettingsFacade = inject(PlatformSettingsFacade);

    paymentMethodsSettingsData$ = this.platformSettingsFacade.paymentMethodsData$;
    paymentMethodsSettingsLoaded$ = this.platformSettingsFacade.paymentMethodsLoaded$;
    paymentMethodsSettingsLoading$ = this.platformSettingsFacade.paymentMethodsLoading$;
    commonSettingsData$ = this.platformSettingsFacade.commonData$;
    commonSettingsLoaded$ = this.platformSettingsFacade.commonLoaded$;
    commonSettingsLoading$ = this.platformSettingsFacade.commonLoading$;

    loadPaymentMethodSettings(): void {
        this.platformSettingsFacade.loadPaymentMethodSettings();
    }

    loadCommonSettings(): void {
        this.platformSettingsFacade.loadCommonSettings();
    }
}
